module.exports = __webpack_public_path__ + "static/app-download-apple-cn-eea8070356c6779a4508ce5dba955eea.png";